// extracted by mini-css-extract-plugin
export default {"emptyWrap":"CatalogIndex_emptyWrap__FiMq4","clear":"CatalogIndex_clear__5aLvn","srOnly":"CatalogIndex_srOnly__6HIdz"};